<template>
  <div>
    <div class="page-form-header">
      <h1>Create your profile</h1>
    </div>
    <div class="container">
      <div class="row">
        <v-form-group :validator="$v.profile.firstName"
                      label="First Name"
                      class="col-6">
          <b-form-input slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="profile.firstName"
                        placeholder="First Name" />
        </v-form-group>
        <v-form-group :validator="$v.profile.lastName"
                      label="Last Name"
                      class="col-6">
          <b-form-input slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="profile.lastName"
                        placeholder="Last Name" />
        </v-form-group>
        <v-form-group :validator="$v.profile.phoneNumber"
                      label="Phone Number"
                      class="col-12">
          <form-input-formatted type="phone"
                                id="phone"
                                v-model="profile.phoneNumber"
                                placeholder="Phone Number" />
        </v-form-group>
        <v-form-group :validator="$v.profile.physicianNPI"
                      label="NPI"
                      class="col-12"
                      v-if="isProvider">
          <b-form-input slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="profile.physicianNPI"
                        placeholder="NPI" />
        </v-form-group>
        <alert-message v-if="showNpiAlertMessage" class="col-12" :message="npiAlertMessage" alert-type="warning"></alert-message>
        <v-form-group v-if="profile.isPatient"
                      :validator="$v.profile.email"
                      label="Email"
                      class="col-12">
          <b-form-input slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="profile.email"
                        placeholder="Email" />

        </v-form-group>
      </div>
    </div>
    <div v-if="!profile.isPatient">
      <b-form-group class="col-12">
        <b-card>
          <div class="row">
            <div class="col-6">Company</div>
            <div class="col text-dark">{{ profile.company }}</div>
          </div>
        </b-card>
      </b-form-group>
      <b-form-group class="col-12">
        <b-card>
          <div class="row">
            <div class="col-6">Administrator</div>
            <div class="col text-dark">{{ profile.inviter }}</div>
          </div>
        </b-card>
      </b-form-group>
    </div>
  </div>
</template>

<script>
  import { required, email, numeric } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers, mapActions } from 'vuex';
  const { mapState } = createNamespacedHelpers('profile');
  import role from "enums/role";
  import AlertMessage from 'components/common/alert-message';

  export default {
    mixins: [formMixin],

    components: {
      AlertMessage
    },

    data() {
      return {
        showNpiAlertMessage: false,
        npiAlertMessage: "Are you sure that you do not want to enter the Provider’s NPI? This is necessary to associate orders with them.",
      };
    },

    validations: {
      profile: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        phoneNumber: {
          required
        },
        email: {
          email
        },
        physicianNPI: {
          numeric
        }
      }
    },

    async mounted() {
      await this.updateProfile();
    },

    computed: {
      ...mapState(["profile"]),

      isProvider() {
        return this.profile.roleId === role.ClientProvider;
      }
    },

    methods: {
      ...mapActions("profile", ["updateProfile"]),

      onSubmit() {
        if (this.isProvider && !this.profile.physicianNPI.length && !this.showNpiAlertMessage) {
          this.showNpiAlertMessage = true;
          return false;
        }
      },
    }
  };
</script>